<template>
    <b-modal
            modal-class="video-modal"
            v-model="displayModal"
            @hidden="hideModal"
            size="xl"
            centered
            hide-footer
            body-class="pt-0 pb-0"
            no-close-on-esc
    >
        <template v-slot:modal-header="{ close }">
            <b-button
                    variant="link"
                    class="close"
                    @click.stop="close"
            >
                <i class="far fa-times" />
            </b-button>
        </template>
        <template v-slot:default>
            <b-embed
                    type="iframe"
                    aspect="16by9"
                    :src="videoSrc"
                    allowfullscreen
            />
        </template>
    </b-modal>
</template>

<script>
    import './VideoModal.scss';

    export const SIMPLE_VIDEO_MODAL_OPEN = 'SIMPLE_VIDEO_MODAL_OPEN';
    export const VIDEO_VIEWED = 'VIDEO_VIEWED';

    export default {
        name: "SimpleVideoModal",
        props: {
            videoSrc: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                displayModal: false
            };
        },
        methods: {
            hideModal() {
                this.$bus.$emit(VIDEO_VIEWED);
                this.displayModal = false;
            },
            onVideoModalOpen() {
                this.displayModal = true;
            }
        },
        beforeMount() {
            this.$bus.$on(SIMPLE_VIDEO_MODAL_OPEN, this.onVideoModalOpen);
        },
        beforeDestroy() {
            this.$bus.$off(SIMPLE_VIDEO_MODAL_OPEN, this.onVideoModalOpen);
        }
    };
</script>